export function getIsMobile(): boolean {
  // breakpoint number are derived from eyekon styles file general.scss
  const VIEWPORT_BREAKPOINT_MOBILE = 1199;
  const width = window.innerWidth ?? 1200;

  return VIEWPORT_BREAKPOINT_MOBILE > width;
}
